import { h } from "harmaja"
import * as L from "lonna"
import { myVotes, voteOn } from "../item-vote"
import { SubmenuProps } from "./ContextMenuView"

// ponytail: inline icons, replace when the UI gets designed
const VoteIcon = ({ minus }: { minus?: boolean }) => (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="10" cy="13" r="6" fill="currentColor" />
        <path d={minus ? "M15 6h6" : "M18 3v6M15 6h6"} />
    </svg>
)

export function votesMenu({ board, focusedItems, dispatch }: SubmenuProps) {
    const votable = L.view(focusedItems, (f) => f.items.filter((i) => i.type === "note" || i.type === "text"))
    return L.view(votable, (items) =>
        items.length === 0
            ? []
            : [
                  <div className="icon-group votes">
                      <span
                          className="icon"
                          title="Vote (V)"
                          onClick={() => voteOn(board.get(), votable.get(), 1, dispatch)}
                      >
                          <VoteIcon />
                      </span>
                      <span
                          className={items.some((i) => myVotes(i) > 0) ? "icon" : "icon disabled"}
                          title="Remove my vote (Shift-V)"
                          onClick={() => voteOn(board.get(), votable.get(), -1, dispatch)}
                      >
                          <VoteIcon minus />
                      </span>
                  </div>,
              ],
    )
}
